import { Card } from "@shopify/polaris";
import AttributeConditions from "../../Conditions/AttributeConditions/AttributeConditions.js";


const SpecificAttributeCard = ({ input }) => {
  return (
    <Card>
      <Card.Section>
        <AttributeConditions input={input} isMultiple={false} meta={{}} />
      </Card.Section>
    </Card>
  );
};

export default SpecificAttributeCard;